import * as R from 'ramda';
import React from 'react';
import { BROADCAST } from '../../constants/platformIds';
import {
    PREMIUM_COLLECTIONS,
    PREMIUM_REPORTS,
    AUDIENCE_INSIGHTS,
    SOCIAL_BENCHMARKING,
    PACING_VIEW_GOALS,
    HOME_PAGE,
    INSIGHT_PAGE,
    SOCIAL_MEDIA_POST_PAGE,
    ALL_SOCIAL_MEDIA_POSTS_PAGE,
    IN_STADIUM_ANALYTICS,
} from '../../constants/config';
import { NestedMenuOption } from './type';

export const getNestedMenuOptions = (
    client: any,
    isMvcRefresh = false,
    t: (key: string) => string = (key: string) => key.split('.').pop() || key,
): Array<NestedMenuOption> => {
    const hasAccessToBroadcastExposure =
        Array.isArray(client.platformIds) &&
        client.platformIds.includes(BROADCAST);
    return [
        // home
        {
            main: {
                path: `/c/${client.id}/`,
                exact: true,
                icon: !isMvcRefresh ? 'fa-home' : 'fa-house',
                title: t('menu.home'),
                permissions: [HOME_PAGE],
            },
        },
        // measurements
        {
            main: {
                icon: !isMvcRefresh
                    ? 'fa-chart-line'
                    : 'fa-square-poll-vertical',
                title: t('menu.measurement'),
            },
            nested: [
                {
                    path: `/c/${client.id}/insights`,
                    title: t('menu.dataExplorer'),
                    permissions: [INSIGHT_PAGE],
                },
                {
                    path: `/c/${client.id}/social-media-posts`,
                    title: t('menu.socialMediaExposure'),
                    permissions: [SOCIAL_MEDIA_POST_PAGE],
                },
                hasAccessToBroadcastExposure && {
                    path: `/c/${client.id}/broadcasts/exposures`,
                    title: t('menu.broadcastExposure'),
                },
                {
                    path: `/c/${client.id}/in-venue`,
                    title: t('menu.inVenue'),
                    permissions: [IN_STADIUM_ANALYTICS],
                },
            ].filter(R.identity),
        },
        {
            main: {
                icon: !isMvcRefresh ? 'fa-images' : 'fa-grid-2',
                title: t('menu.ownedSocial'),
            },
            nested: [
                {
                    path: `/c/${client.id}/all-social-media-posts`,
                    title: t('menu.socialPostMetrics'),
                    permissions: [ALL_SOCIAL_MEDIA_POSTS_PAGE],
                },
                {
                    title: t('menu.audience'),
                    path: `/c/${client.id}/audience`,
                    permissions: [AUDIENCE_INSIGHTS],
                },
            ],
        },
        {
            main: {
                icon: !isMvcRefresh ? 'fa-medal' : 'fa-bullseye-arrow',
                title: t('menu.benchmarking'),
            },
            nested: [
                {
                    path: `/c/${client.id}/social-benchmarking`,
                    title: t('menu.socialBenchmarking'),
                    permissions: [SOCIAL_BENCHMARKING],
                },
            ],
        },
        {
            main: {
                icon: !isMvcRefresh ? 'fa-toolbox' : 'fa-screwdriver-wrench',
                title: t('menu.tools'),
            },
            nested: [
                {
                    path: `/c/${client.id}/reports`,
                    title: t('menu.reports'),
                    permissions: [PREMIUM_REPORTS],
                },
                {
                    path: `/c/${client.id}/pacing`,
                    title: t('menu.pacing'),
                    permissions: [PACING_VIEW_GOALS],
                },
                {
                    path: `/c/${client.id}/collections`,
                    title: t('menu.collections'),
                    permissions: [PREMIUM_COLLECTIONS],
                },
            ],
        },
    ];
};

export const getBreadcrumbMap = (t: (key: string) => string) => ({
    '': [
        <>
            <i className={`fa-regular fa-house -m-r-2`} />
            {t('breadcrumbs.home')}
        </>,
    ],
    insights: [
        <>
            {' '}
            <i className={`fa-regular fa-square-poll-vertical -m-r-2`} />
            {t('breadcrumbs.measurement')}
        </>,
        t('breadcrumbs.dataExplorer'),
    ],
    'social-media-posts': [
        <>
            {' '}
            <i className={`fa-regular fa-square-poll-vertical -m-r-2`} />
            {t('breadcrumbs.measurement')}
        </>,
        t('breadcrumbs.socialMediaExposure'),
    ],
    broadcasts: [
        <>
            {' '}
            <i className={`fa-regular fa-square-poll-vertical -m-r-2`} />
            {t('breadcrumbs.measurement')}
        </>,
        t('breadcrumbs.broadcastExposure'),
    ],
    'in-venue': [
        <>
            {' '}
            <i className={`fa-regular fa-square-poll-vertical -m-r-2`} />
            {t('breadcrumbs.measurement')}
        </>,
        t('breadcrumbs.inVenue'),
    ],
    'all-social-media-posts': [
        <>
            {' '}
            <i className={`fa-regular fa-grid-2 -m-r-2`} />
            {t('breadcrumbs.ownedSocial')}
        </>,
        t('breadcrumbs.socialPostMetrics'),
    ],
    audience: [
        <>
            {' '}
            <i className={`fa-regular fa-grid-2 -m-r-2`} />
            {t('breadcrumbs.ownedSocial')}
        </>,
        t('breadcrumbs.audience'),
    ],
    'social-benchmarking': [
        <>
            {' '}
            <i className={`fa-regular fa-bullseye-arrow -m-r-2`} />
            {t('breadcrumbs.benchmarking')}
        </>,
        t('breadcrumbs.socialBenchmarking'),
    ],
    reports: [
        <>
            {' '}
            <i className={`fa-regular fa-screwdriver-wrench -m-r-2`} />
            {t('breadcrumbs.tools')}
        </>,
        t('breadcrumbs.reports'),
    ],
    pacing: [
        <>
            {' '}
            <i className={`fa-regular fa-screwdriver-wrench -m-r-2`} />
            {t('breadcrumbs.tools')}
        </>,
        t('breadcrumbs.pacing'),
    ],
    collections: [
        <>
            {' '}
            <i className={`fa-regular fa-screwdriver-wrench -m-r-2`} />
            {t('breadcrumbs.tools')}
        </>,
        t('breadcrumbs.collections'),
    ],
});
